/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import WebsiteDeactive from '../../assets/svgs/WebsiteDeactive';
import WebsiteActive from '../../assets/svgs/WebsiteActive';
import { setLicense } from '../../actions/License/setLicenseActions';

const WebsitesItem = ({ className, url, active, id }) => {
    const dispatch = useDispatch();

    const setActive = id => {
        dispatch(setLicense(id));
        sessionStorage.removeItem('filter');
        sessionStorage.removeItem('order');
    };

    return (
        <div className={className} onClick={() => setActive(id)}>
            <span className="Webiste__Url">{url}</span>
            {active ? <WebsiteActive /> : <WebsiteDeactive />}
        </div>
    );
};

WebsitesItem.propTypes = {
    className: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired
};

export default styled(WebsitesItem)`
    display: flex;
    flex-flow: row-reverse wrap;
    justify-content: space-between;
    width: 100%;
    max-width: 297px;
    background: ${({ active }) => (active ? '#E8EBFF' : '#ffffff')};
    border-radius: 5px;
    box-shadow: 0 3px 10px #e8ebff;
    margin-bottom: 12px;
    padding: 13px 25px 13px 33px;
    cursor: pointer;

    > .Webiste__Url {
        direction: ltr;
        font-size: 14px;
        font-weight: bold;
        line-height: 25px;
        color: #0d1fa1;
        margin: 0;
    }

    ${({ active }) => active && `svg { margin-right: -10px;}`}
`;
